<template>
    <div class="content">
        <ErrorLogList :isCollaborator="false" />
    </div>
</template>

<script>
    export default {
        name: "Logs",
        components: {
            ErrorLogList: () =>
                import(/* webpackChunkName: "siteList" */ "../../../../components/User/Sites/Logs/ErrorLogList.vue"),
        }
    }
</script>

<style scoped>

</style>
